import classnames from "classnames";
import { usePunditUserContext } from "@circle-react/contexts";
import { PopoverPortal } from "@circle-react-uikit/PopoverPortal";
import { DEFAULT_POPPER_OPTIONS } from "../constants";
import { BookmarksList } from "./BookmarksList";
import { BookmarksPopoverButton } from "./BookmarksPopoverButton";

export const Bookmarks = () => {
  const { currentCommunityMember, isViewOnlyMasquerading } =
    usePunditUserContext();

  if (!currentCommunityMember) {
    return null;
  }

  return (
    <PopoverPortal
      renderButton={isOpen => <BookmarksPopoverButton isOpen={isOpen} />}
      className={classnames(
        "border-primary bg-primary size-full max-h-[37rem] max-w-[30rem] rounded-lg border shadow-lg",
        {
          "cursor-not-allowed": isViewOnlyMasquerading,
        },
      )}
      popperOptions={DEFAULT_POPPER_OPTIONS}
      shouldHideOnMdScreens={false}
    >
      <div
        className={classnames("size-full", {
          "pointer-events-none": isViewOnlyMasquerading,
        })}
        data-testid="bookmarks-drawer"
      >
        <BookmarksList />
      </div>
    </PopoverPortal>
  );
};
